var MountingHoleData = require('./mountingHoleData.js');
var lib_core = require("lib-core");
var PthComponentAttribute = require('./pthComponentAttribute.js');

var StandoffSpacerData = function(position, angle, init) {
    var self = this;
    MountingHoleData.apply(this, arguments);

    this.gender = this.value("gender", true);

    this.bodyShape = this.value("bodyShape", true);
    this.bodyShape(PthComponentAttribute.type.ELECTRO_MECHANICAL.types.STANDOFF_SPACER.bodyShapes["HEX"]);

    this.nonTransformedSegmentedGeometry.addTrigger(this.gender);
    this.nonTransformedSegmentedGeometry.addTrigger(this.bodyShape);
};

lib_core.inherit(StandoffSpacerData, MountingHoleData);
lib_core.JsonParser.registerClass(StandoffSpacerData, "StandoffSpacerData");

module.exports = StandoffSpacerData;